import { PageHeader, Tabs } from "antd";
import { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import BaseLayout from "../../components/BaseLayout";
import useSpuPoints from "../../stores/spuPoints";
import useSpuInfo from "../../stores/spuInfo";
import Performance from "./Performance/index";
import MultiSpeed from "./MultiSpeed";
import SeriesParallel from "./SeriesParallel";
import Tools from "./Tools";
import Info from "./Description";
import useSpuPdfParam from "../../stores/spuPdfParam";
import PerformanceSpeed from "./PerformanceSpeed";
import ParameterSheetWorkbench from "./ParameterSheetWorkbench";

// spu 列表

const Spu = () => {
  const { t } = useTranslation();
  const navgiate = useNavigate();
  const { search } = useLocation();
  
  const { id, tab } = useParams() as { id: string; tab: string };
  const { fetch: fetchPoints, name, dataset, dataSource } = useSpuPoints();
  const { fetch: fetchInfo, spu } = useSpuInfo();
  const { fetch: fetchPdfParameter } = useSpuPdfParam();

  const title = name || spu || t("route.chart");
  const loaded = dataset !== undefined && dataSource !== undefined;
  const [parameterSheetMapping] = useState(() => {
    const params = new URLSearchParams(search);
    return {
      series: params.get("psSeries") || "",
      model: params.get("psModel") || "",
    };
  });
  const hasParameterSheetMapping =
    Boolean(parameterSheetMapping.series) &&
    Boolean(parameterSheetMapping.model);
  const activeTab = tab || "performance";
  const showParameterSheetWorkbench =
    hasParameterSheetMapping && activeTab === "info2";

  const handleTabChange = (key: string) => {
    if (!key) {
      return;
    }

    const nextParams = new URLSearchParams(search);
    if (hasParameterSheetMapping) {
      nextParams.set("psSeries", parameterSheetMapping.series);
      nextParams.set("psModel", parameterSheetMapping.model);
    }
    const query = nextParams.toString();
    navgiate(`/spus/${id}/${key}${query ? `?${query}` : ""}`);
  };

  useEffect(() => {
    fetchInfo(id);
    fetchPdfParameter(id);
    fetchPoints(id);
  }, [fetchPoints, fetchInfo, fetchPdfParameter, id]);

  return (
    <BaseLayout title={title}>
      <PageHeader
        title={title}
        style={{ padding: "16px 0" }}
        extra={<Tools loaded={loaded} />}
      />
      <Tabs
        activeKey={activeTab}
        size="large"
        onChange={handleTabChange}
        destroyInactiveTabPane={false}
      >
        <Tabs.TabPane
          tab={t("spuChart.tab.performance")}
          key="performance"
          forceRender={true}
        >
          <Performance />
        </Tabs.TabPane>
        <Tabs.TabPane
          tab={t("spuChart.tab.performanceAndSpeed")}
          key="performanceSpeed"
        >
          <PerformanceSpeed />
        </Tabs.TabPane>
        <Tabs.TabPane tab={t("spuChart.tab.speed")} key="multiSpeed">
          <MultiSpeed />
        </Tabs.TabPane>
        <Tabs.TabPane
          tab={t("spuChart.tab.seriesParallel")}
          key="seriesParallel"
        >
          <SeriesParallel />
        </Tabs.TabPane>
        {!hasParameterSheetMapping && (
          <Tabs.TabPane tab={t("spuChart.tab.description")} key="info">
            <Info />
          </Tabs.TabPane>
        )}
        {hasParameterSheetMapping && (
          <Tabs.TabPane
            tab={t("spuChart.tab.description2")}
            key="info2"
            forceRender={true}
          />
        )}
      </Tabs>
      {hasParameterSheetMapping && (
        <div
          style={{
            height: showParameterSheetWorkbench ? "auto" : 0,
            overflow: "hidden",
            pointerEvents: showParameterSheetWorkbench ? "auto" : "none",
            visibility: showParameterSheetWorkbench ? "visible" : "hidden",
          }}
        >
          <ParameterSheetWorkbench
            psSeries={parameterSheetMapping.series}
            psModel={parameterSheetMapping.model}
          />
        </div>
      )}
    </BaseLayout>
  );
};

export default Spu;
